import { TanStackDevtools } from '@tanstack/react-devtools';
import { pacerDevtoolsPlugin } from '@tanstack/react-pacer-devtools';
import { RhinoDevToolPanel } from './RhinoDevToolPanel';

export const RhinoDevTool = () => (
  <TanStackDevtools
    config={{ position: 'top-right' }}
    plugins={[
      {
        name: 'Rhino',
        // The shell re-invokes render whenever its theme setting changes, so
        // the panel tracks the devtools theme (not the host app's).
        render: (_el, { theme }) => <RhinoDevToolPanel theme={theme} />
      },
      pacerDevtoolsPlugin()
    ]}
  />
);
